import { CloseOutlined } from '@ant-design/icons'
import React from 'react'
import styled from 'styled-components'

import type { Attachment } from 'features/bug-report/types'

type Props = {
  attachments: Attachment[]
  onRemove: (id: string) => void
}

export const AttachmentList: React.FC<Props> = ({ attachments, onRemove }) => {
  if (attachments.length === 0) return null
  return (
    <List>
      {attachments.map((a) => (
        <Item key={a.id}>
          <Label>{a.label}</Label>
          <RemoveButton
            type="button"
            onClick={() => onRemove(a.id)}
            aria-label={`Remove ${a.label}`}
          >
            <CloseOutlined />
          </RemoveButton>
        </Item>
      ))}
    </List>
  )
}

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 12px;
`

const Item = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  background: #f5f5f5;
  border-radius: 4px;
  font-size: 12px;
`

const Label = styled.span`
  flex: 1;
  color: #000;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const RemoveButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  color: #8c8c8c;
  padding: 0;
  display: inline-flex;
  align-items: center;

  &:hover {
    color: #000;
  }
`
